import script from "./Anniversary.vue?vue&type=script&setup=true&lang=js"
export * from "./Anniversary.vue?vue&type=script&setup=true&lang=js"

import "./Anniversary.vue?vue&type=style&index=0&id=1d8eda6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d8eda6a"]])

export default __exports__